/* eslint-disable*/

import { Box, colors } from '@material-ui/core'; // eslint-disable-line
import { useSelector } from 'react-redux';
import { useState } from 'react';
import {
  selectAmazonCategoryGraph,
  selectRakutenCategoryGraph,
  selectYahooCategoryGraph,
  categorygraphStatus
} from 'feactures/brand/categoryBrandGraphSlice';
import {
  amazonCategory,
  rakutenCategory,
  yahooCategory
} from 'feactures/category/categorySlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import CategoryTotalgraph from 'components/molecules/dashboard/CategoryTotalgraph';
import CategoryTotalSales from 'components/molecules/dashboard/CategoryTotalSales';

const BrandTotal = (props) => {
  // 実際のデータはuseEffectで取得しreduxへ
  const { yokoziku } = props;
  let categoryAmazonGraphData = useSelector(selectAmazonCategoryGraph);
  let categoryRakutenGraphData = useSelector(selectRakutenCategoryGraph);
  const categoryYahooGraphData = useSelector(selectYahooCategoryGraph);
  const amazonCategories = useSelector(amazonCategory);
  const rakutenCategories = useSelector(rakutenCategory);
  const yahooCategories = useSelector(yahooCategory);
  const loading = useSelector(categorygraphStatus);
  const channel = useSelector(currentchannel);
  const yoko = [...yokoziku];
  const [tanni, setTanni] = useState('億円');

  let categoryGraphData = {
    graphdata: [],
    totalsalesData: '',
    totalunitData: '',
    selectCategoryLabel: '',
    lastmonthRate: '',
    lastyearRate: ''
  };
  let mall = '';
  let color = '';
  let categories = '';

  if (channel == 1) {
    const targetDate = '2023/2';
    const index = yokoziku.findIndex((date) => date === targetDate);
    if (index !== -1 && categoryAmazonGraphData.graphdata.length > 0) {
      yoko.splice(0, index + 1);
      let newData = JSON.parse(JSON.stringify(categoryAmazonGraphData)); // オブジェクト全体をコピー
      newData.graphdata.splice(0, index + 1); // graphdataを変更
      categoryAmazonGraphData = newData; // 新しいオブジェクトを代入
    }

    categoryGraphData = categoryAmazonGraphData;
    mall = 'Amazon';
    color = colors.amber[700];
    categories = amazonCategories;
  } else if (channel == 2) {
    const targetDate = '2023/7';
    const index = yokoziku.findIndex((date) => date === targetDate);
    if (index !== -1 && categoryRakutenGraphData.graphdata.length > 0) {
      yoko.splice(0, index + 1);
      let newData = JSON.parse(JSON.stringify(categoryRakutenGraphData)); // オブジェクト全体をコピー
      newData.graphdata.splice(0, index + 1); // graphdataを変更
      categoryRakutenGraphData = newData; // 新しいオブジェクトを代入
    }

    categoryGraphData = categoryRakutenGraphData;
    mall = '楽天市場';
    color = '#bf0000';
    categories = rakutenCategories;
  } else if (channel == 3) {
    categoryGraphData = categoryYahooGraphData;
    mall = 'Yahoo';
    color = '#FF0027';
    categories = yahooCategories;
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ flex: '0 0 auto', mb: 0.5 }}>
        <CategoryTotalSales sales={categoryGraphData.totalsalesData} />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, width: '100%' }}>
        <CategoryTotalgraph
          mall={mall}
          graphdata={categoryGraphData.graphdata}
          color={color}
          categories={categories}
          channel={channel}
          yokoziku={yoko}
          setTanni={setTanni}
        />
      </Box>
    </Box>
  );
};

export default BrandTotal;
